export interface IProduct {
  id: number;
  uuid: string;
  parentId: number;
  description: string;
  imageUrl: string;
  position: number;
  isCategory: boolean;
  price: number;
  qty: number;
  textColour: string;
  buttonColour: string;
  zone: number;
  barcode: string;
}

export const defaultProduct: IProduct = {
  id: 0,
  uuid: "",
  parentId: 0,
  description: "",
  imageUrl: "",
  position: 0,
  isCategory: false,
  price: 0,
  qty: 0,
  textColour: "",
  buttonColour: "",
  zone: 0,
  barcode: "",
};
